export enum ActivityReviewPageParams {
  activityReviewActivityUuid = "activityReviewActivityUuid",
  activityReviewUuid = "activityReviewUuid",
}
